module.exports = __webpack_public_path__ + "whiteoilleaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whiteoilleaf.png
// module id = 897
// module chunks = 0